import React, { useState, useEffect, useContext } from 'react';
import './DailyPanchang.css';
import octoberPanchangData from '../data/October_2025_panchang.json';
import novemberPanchangData from '../data/November_panchang.json'
import decemberPanchangData from '../data/December_2025_panchang.json';
import { LanguageContext } from "../context/LanguageContext";

export default function DailyPanchang() {
  const [isOpen, setIsOpen] = useState(false);
  const [panchang, setPanchang] = useState(null);
  
  const { lang } = useContext(LanguageContext);
  const today = new Date().toISOString().split('T')[0];
  console.log("asdsd",today);

  // --- HELPER FUNCTIONS ---

  const toDevanagariNumber = (num) => {
    if (typeof num !== 'string' && typeof num !== 'number') return '';
    const devanagariDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    return num.toString().split('').map(digit => devanagariDigits[digit] || digit).join('');
  };

  const fromDevanagariNumber = (str) => {
    if (typeof str !== 'string') return str;
    const devanagariDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    let newStr = str;
    for (let i = 0; i < 10; i++) {
      newStr = newStr.replace(new RegExp(devanagariDigits[i], 'g'), englishDigits[i]);
    }
    return newStr;
  };

  const getDisplayDate = () => {
    const date = new Date();
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const monthNames = {
      en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      mr: ['जाने', 'फेब्रु', 'मार्च', 'एप्रिल', 'मे', 'जून', 'जुलै', 'ऑग', 'सप्टें', 'ऑक्टो', 'नोव्हें', 'डिसें']
    };
    return { day, month: { en: monthNames.en[monthIndex], mr: monthNames.mr[monthIndex] } };
  };

  const dateInfo = getDisplayDate();

  // --- DATA & TRANSLATIONS ---

  // *** THIS IS THE CORRECTED SECTION ***
  useEffect(() => {
    if (isOpen) {
      let todayPanchang = null;

      // Check if the JSON is an object with a 'data' array property
      if (decemberPanchangData && Array.isArray(decemberPanchangData.data)) {
        todayPanchang = decemberPanchangData.data.find(item => item.date === today);
      } 
      // Else, check if the JSON itself is the array (this handles the error)
      else if (Array.isArray(decemberPanchangData)) {
        todayPanchang = decemberPanchangData.find(item => item.date === today);
      }
      
      setPanchang(todayPanchang || null); // Set the found data, or null if not found
    }
  }, [isOpen, today]);
  // *** END OF CORRECTION ***

  const translations = {
    // Days of week
    'रविवार': 'Sunday', 'सोमवार': 'Monday', 'मंगळवार': 'Tuesday', 'बुधवार': 'Wednesday', 'गुरुवार': 'Thursday', 'शुक्रवार': 'Friday', 'शनिवार': 'Saturday',
    // Paksha
    'कृष्ण पक्ष': 'Krishna Paksha', 'शुक्ल पक्ष': 'Shukla Paksha',
    // Tithis
    'प्रतिपदा': 'Pratipada', 'द्वितीया': 'Dwitiya', 'तृतीया': 'Tritiya', 'चतुर्थी': 'Chaturthi', 'पंचमी': 'Panchami', 'षष्ठी': 'Shashthi', 'सप्तमी': 'Saptami', 'अष्टमी': 'Ashtami', 'नवमी': 'Navami', 'दशमी': 'Dashami', 'एकादशी': 'Ekadashi', 'द्वादशी': 'Dwadashi', 'त्रयोदशी': 'Trayodashi', 'चतुर्दशी': 'Chaturdashi', 'पौर्णिमा': 'Purnima', 'अमावस्या': 'Amavasya',
    // Nakshatras
    'अश्विनी': 'Ashwini', 'भरणी': 'Bharani', 'कृत्तिका': 'Krittika', 'रोहिणी': 'Rohini', 'मृगशिरा': 'Mrigashira', 'आर्द्रा': 'Ardra', 'पुनर्वसु': 'Punarvasu', 'पुष्य': 'Pushya', 'अश्लेषा': 'Ashlesha', 'मघा': 'Magha', 'पूर्वा फाल्गुनी': 'Purva Phalguni', 'उत्तरा फाल्गुनी': 'Uttara Phalguni', 'हस्त': 'Hasta', 'चित्रा': 'Chitra', 'स्वाती': 'Swati', 'विशाखा': 'Vishakha', 'अनुराधा': 'Anuradha', 'ज्येष्ठा': 'Jyeshtha', 'मूळ': 'Moola', 'पूर्वाषाढा': 'Purva Ashadha', 'उत्तराषाढा': 'Uttara Ashadha', 'उ. षा.': 'U. Shaa.', 'श्रवण': 'Shravana', 'धनिष्ठा': 'Dhanishtha', 'शतभिषा': 'Shatabhisha', 'पूर्वा भाद्रपदा': 'Purva Bhadrapada', 'उत्तरा भाद्रपदा': 'Uttara Bhadrapada', 'रेवती': 'Revati',
    // Yogas
    'विष्कम्भ': 'Vishkambha', 'प्रीती': 'Preeti', 'आयुष्मान': 'Ayushman', 'सौभाग्य': 'Saubhagya', 'शोभन': 'Shobhana', 'अतिगंड': 'Atiganda', 'सुकर्मा': 'Sukarma', 'धृती': 'Dhriti', 'शूळ': 'Shoola', 'गंड': 'Ganda', 'वृद्धी': 'Vriddhi', 'ध्रुव': 'Dhruva', 'व्याघात': 'Vyaghata', 'हर्षण': 'Harshana', 'वज्र': 'Vajra', 'सिद्धी': 'Siddhi', 'व्यतीपात': 'Vyatipata', 'वरीयान': 'Variyana', 'परिघ': 'Parigha', 'शिव': 'Shiva', 'सिद्ध': 'Siddha', 'साध्य': 'Sadhya', 'शुभ': 'Shubha', 'शुक्ल': 'Shukla', 'ब्रह्म': 'Brahma', 'इंद्र': 'Indra', 'वैधृती': 'Vaidhriti',
    // Karanas
    'बव': 'Bava', 'बालव': 'Balava', 'कौलव': 'Kaulava', 'तैतिल': 'Taitila', 'गर': 'Gara', 'वणिज': 'Vanija', 'विष्टि': 'Vishti', '(भद्रा)': '(Bhadra)', 'शकुनी': 'Shakuni', 'चतुष्पाद': 'Chatushpada', 'नाग': 'Naga', 'किंस्तुघ्न': 'Kimstughna',
    // Rashis
    'मेष': 'Aries', 'वृषभ': 'Taurus', 'मिथुन': 'Gemini', 'कर्क': 'Cancer', 'सिंह': 'Leo', 'कन्या': 'Virgo', 'तुला': 'Libra', 'वृश्चिक': 'Scorpio', 'धनु': 'Sagittarius', 'मकर': 'Capricorn', 'कुंभ': 'Aquarius', 'मीन': 'Pisces',
    // Months
    'चैत्र': 'Chaitra', 'वैशाख': 'Vaishakha', 'ज्येष्ठ': 'Jyeshtha', 'आषाढ': 'Ashadha', 'श्रावण': 'Shravana', 'भाद्रपद': 'Bhadrapada', 'आश्विन': 'Ashwin', 'कार्तिक': 'Kartika', 'मार्गशीर्ष': 'Margashirsha', 'पौष': 'Pausha', 'माघ': 'Magha', 'फाल्गुन': 'Phalguna',
    // Common Terms
    'प. नं.': 'upto... then',
  };

  const labels = {
    date: { en: 'Date', mr: 'दिनांक' },
    vaar: { en: 'Day', mr: 'वार' },
    tithi: { en: 'Tithi', mr: 'तिथी' },
    nakshatra: { en: 'Nakshatra', mr: 'नक्षत्र' },
    yog: { en: 'Yoga', mr: 'योग' },
    karan: { en: 'Karan', mr: 'करण' },
    maas: { en: 'Month', mr: 'मास' },
    paksha: { en: 'Paksha', mr: 'पक्ष' },
    chandra_rashi: { en: 'Moon Sign', mr: 'चंद्र राशी' },
    surya_rashi: { en: 'Sun Sign', mr: 'सूर्य राशी' },
    guru_rashi: { en: 'Jupiter Sign', mr: 'गुरु राशी' },
    rahukaal: { en: 'Rahukaal', mr: 'राहुकाल' },
    guruwani: { en: "Guru's Message", mr: 'गुरुवाणी' },
    noData: { en: 'Data not available for today', mr: 'आजसाठी डेटा उपलब्ध नाही' }
  };

  // --- FORMATTING FUNCTIONS ---

  const formatComplexValue = (marathiText) => {
    if (!marathiText) return '';
    let englishText = marathiText;
    // const sortedKeys = Object.keys(translations).sort((a, b) => b.length - a.length);
    // for (const key of sortedKeys) {
    //   englishText = englishText.replace(new RegExp(key, 'g'), translations[key]);
    // }
    // englishText = fromDevanagariNumber(englishText);
    return `${englishText}`;
  };

  const formatSimpleValue = (marathiText) => {
    if (!marathiText) return '';
    const englishText = translations[marathiText] || marathiText;
    return `${englishText} (${marathiText})`;
  };
  
  const formatRahukaal = (marathiText) => {
    if (!marathiText) return '';
    let englishText = marathiText;
    const timeOfDay = { 'दुपारी': 'Afternoon', 'सकाळी': 'Morning', 'सायं.': 'Evening' };
    for (const [mr, en] of Object.entries(timeOfDay)) {
        englishText = englishText.replace(mr, en);
    }
    englishText = englishText.replace('ते', 'to');
    englishText = fromDevanagariNumber(englishText);
    return `${englishText} (${marathiText})`;
  };
  
  const formatDualLanguageDate = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-'); // YYYY-MM-DD
    const [year, month, day] = parts;
    const enDate = `${day}-${month}-${year}`;
    const mrDate = `${toDevanagariNumber(day)}-${toDevanagariNumber(month)}-${toDevanagariNumber(year)}`;
    return `${enDate} (${mrDate})`;
  };

  // --- RENDER ---

  return (
    <>
      <div className="panchang-card" onClick={() => setIsOpen(true)}>
        <div className="panchang-icon">
          <span className="calendar-month">{dateInfo.month[lang]}</span>
          <span className="calendar-day">{lang === 'mr' ? toDevanagariNumber(dateInfo.day) : dateInfo.day}</span>
        </div>
        <div>
          <strong>{lang === 'en' ? 'Daily Panchang' : 'दैनिक पंचांग'}</strong>
          <p>{lang === 'en' ? 'Click to view details' : 'तपशील पाहण्यासाठी क्लिक करा'}</p>
        </div>
      </div>

      {isOpen && (
        <div className="panchang-modal-backdrop" onClick={() => setIsOpen(false)}>
          <div className="panchang-modal" onClick={(e) => e.stopPropagation()}>
            <header>
              <h2>Daily Panchang (दैनिक पंचांग)</h2>
              <button className="close-btn" onClick={() => setIsOpen(false)}>×</button>
            </header>
            <div className="panchang-content">
              {!panchang ? (
                <p>{labels.noData.en} / {labels.noData.mr}</p>
              ) : (
                <table>
                  <tbody>
                    <tr>
                      <td>{labels.date.en} ({labels.date.mr})</td>
                      <td>{formatDualLanguageDate(panchang.date)}</td>
                    </tr>
                    <tr>
                      <td>{labels.vaar.en} ({labels.vaar.mr})</td>
                      <td>{formatSimpleValue(panchang.vaar)}</td>
                    </tr>
                    <tr>
                      <td>{labels.tithi.en} ({labels.tithi.mr})</td>
                      <td>{formatComplexValue(panchang.tithi)}</td>
                    </tr>
                    <tr>
                      <td>{labels.paksha.en} ({labels.paksha.mr})</td>
                      <td>{formatSimpleValue(panchang.paksha)}</td>
                    </tr>
                    <tr>
                      <td>{labels.nakshatra.en} ({labels.nakshatra.mr})</td>
                      <td>{formatComplexValue(panchang.nakshatra)}</td>
                    </tr>
                    <tr>
                      <td>{labels.yog.en} ({labels.yog.mr})</td>
                      <td>{formatComplexValue(panchang.yog)}</td>
                    </tr>
                    <tr>
                      <td>{labels.karan.en} ({labels.karan.mr})</td>
                      <td>{formatComplexValue(panchang.karan)}</td>
                    </tr>
                    {panchang.maas && (
                      <tr>
                        <td>{labels.maas.en} ({labels.maas.mr})</td>
                        <td>{formatSimpleValue(panchang.maas)}</td>
                      </tr>
                    )}
                    <tr>
                      <td>{labels.chandra_rashi.en} ({labels.chandra_rashi.mr})</td>
                      <td>{formatSimpleValue(panchang.chandra_rashi)}</td>
                    </tr>
                    <tr>
                      <td>{labels.surya_rashi.en} ({labels.surya_rashi.mr})</td>
                      <td>{formatSimpleValue(panchang.surya_rashi)}</td>
                    </tr>
                    {panchang.guru_rashi && (
                      <tr>
                        <td>{labels.guru_rashi.en} ({labels.guru_rashi.mr})</td>
                        <td>{formatSimpleValue(panchang.guru_rashi)}</td>
                      </tr>
                    )}
                    <tr>
                      <td>{labels.rahukaal.en} ({labels.rahukaal.mr})</td>
                      <td>{formatRahukaal(panchang.rahukaal)}</td>
                    </tr>
                    {panchang.guruwani && (
                      <tr>
                        <td colSpan="2" style={{ fontStyle: 'italic', paddingTop: '12px' }}>
                          <strong>💡 {labels.guruwani.en} ({labels.guruwani.mr}):</strong><br/>
                          {formatComplexValue(panchang.guruwani)}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}